export const types = {
  UPLOAD_DETAILS_MODAL_OPEN:
    'modules/common/modals/uploadDetailsModal/UPLOAD_DETAILS_MODAL_OPEN',
  UPLOAD_DETAILS_MODAL_CONFIRM:
    'modules/common/modals/uploadDetailsModal/UPLOAD_DETAILS_MODAL_CONFIRM',
  UPLOAD_DETAILS_MODAL_CLOSE:
    'modules/common/modals/uploadDetailsModal/UPLOAD_DETAILS_MODAL_CLOSE',
};

export const uploadDetailsModal = {
  open: ({
    filename,
    shouldEnterThickness,
    shouldEnterUnits,
    similarFiles,
    thickness,
    currentUnits,
  }) => ({
    type: types.UPLOAD_DETAILS_MODAL_OPEN,
    payload: {
      filename,
      shouldEnterThickness,
      shouldEnterUnits,
      similarFiles,
      thickness,
      currentUnits,
    },
  }),
  confirm: ({ applyToAll, thickness, units }) => ({
    type: types.UPLOAD_DETAILS_MODAL_CONFIRM,
    payload: { applyToAll, thickness, units },
  }),
  close: () => ({
    type: types.UPLOAD_DETAILS_MODAL_CLOSE,
  }),
};
